// extracted by mini-css-extract-plugin
export default {"vertical-icon":"LeadsKanbanCard_vertical-icon__ww6a-"};